import script from "./HospitalPersonalInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalPersonalInfo.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalPersonalInfo.vue?vue&type=style&index=0&id=54d2432c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d2432c"]])

export default __exports__